import { TypedEmitter } from 'tiny-typed-emitter'
import { MuseRtcMediaTrackStats, RtcStatsCandidatePairType, RtcStatsCandidatePairTypeExt } from './RtcStatsTypes'
import { AudioEngineNetworkStats } from '../../core/AudioEngine'
import { MidiStats } from '../../RoomContext'
import { HostPingMeasurement } from '../../services/usePeerPingMeasurement'

export type MuseRtcStats = {
    rtcOverviewStats: RtcStatsCandidatePairType | null
    mediaTrackStats: { [key: string /*track id*/]: MuseRtcMediaTrackStats | null } | null
}

export type SystemResourceUsageStats = {
    cpuUser: number
    cpuSystem: number
    memory: number
}

export type SystemStats = {
    rtcOverviewStats: RtcStatsCandidatePairTypeExt | null
    mediaTrackStats: { [key: string /*track id*/]: MuseRtcMediaTrackStats | null } | null
    systemResourceUsageStats: SystemResourceUsageStats | null
    pingMeasurement: HostPingMeasurement | null
    audioEngineNetworkStats: AudioEngineNetworkStats
    audioEnginePerStreamReceptionStats: any
    midiStats: MidiStats
}

interface SystemStatsEvents {
    data: (data: SystemStats) => void
}

export class SystemStatsEmitterClass extends TypedEmitter<SystemStatsEvents> {
    write(data: SystemStats) {
        this.emit('data', data)
    }
}

export const systemStatsEmitter = new SystemStatsEmitterClass()
